/**
 * @file project-io.ts
 * @description Main facade for HCIE project serialization and format conversion.
 * Delegates to specialized sub-modules to stay under 250 lines.
 */

import { ProjectSerializer } from './project/serializer';
import { ProjectImporter } from './project/importer';
import { ProjectExporter } from './project/exporter';

export class ProjectIO {
  /**
   * Serializes the current global state and layers into a JSON string.
   */
  static async saveProject(): Promise<string> {
    return ProjectSerializer.saveProject();
  }

  /**
   * Reconstructs the global state and layers from an HCIE project JSON string.
   */
  static async loadProject(jsonString: string): Promise<boolean> {
    return ProjectSerializer.loadProject(jsonString);
  }

  /**
   * Imports an image file buffer into the application as a new document.
   */
  static async importImage(buffer: ArrayBuffer, fileName: string): Promise<boolean> {
    return ProjectImporter.importImage(buffer, fileName);
  }

  /**
   * Exports the current project to a binary buffer or string in the specified format.
   */
  static async exportImage(formatExt: string): Promise<Uint8Array | string> {
    return ProjectExporter.exportImage(formatExt);
  }
}

